import { LuCopy } from "react-icons/lu"

import BackgroundWrapper from "@fuse/sharedComponents/backgroundWrapper"

import {
  DeviceTypes,
  DownloadLinkMap,
  onOpenDownloadLink,
} from "@fuse/utils/DeviceDection"

import appStore from "@fuse/assets/images/img-app-store.svg"
import playStore from "@fuse/assets/images/img-play-store.svg"

import "./style.css"

const EventBanner2 = ({
  eventId,
  flyerImage,
}: {
  eventId: string
  flyerImage: string
}) => {
  const url = `https://letshang.co/share/events/${eventId}`

  const copyToClipboard = () => {
    navigator.clipboard.writeText(url)
    alert("Link copied to clipboard!")
  }

  return (
    <BackgroundWrapper bgImage={flyerImage}>
      {/* <div className="flex inset-0 absolute -z-10 blur-lg bg-black opacity-50"></div> */}
      <div className="text-center space-y-4 blurTypeDark py-12 px-6">
        <h3 className="text-2xl md:text-5xl text-white font-medium font-dm">
          Get the app now
        </h3>
        <p className="text-white/80 text-sm py-2 md:py-4">
          Download the app for easy coordination.
          <br /> If you have trouble finding the event after downloading, copy
          and paste the link below into the search bar.
        </p>

        {/* Event Link */}
        <div className="flex items-center justify-center px-4 py-2 rounded-full text-gray-200 w-full max-w-xl mx-auto blurTypeLight border border-white/20">
          <input
            type="text"
            value={url}
            readOnly
            className="bg-transparent w-full outline-none text-center"
          />
          <button
            onClick={copyToClipboard}
            className="bg-transparent p-0 border-transparent focus:border-transparent focus:ring-0 focus:outline-none px-2"
          >
            <LuCopy color="white" size={22} />
          </button>
        </div>

        {/* App Download Links */}
        <div className="flex justify-center space-x-4 pt-2 md:pt-4">
          <div
            className="cursor-pointer"
            onClick={() => {
              onOpenDownloadLink(DownloadLinkMap[DeviceTypes.IOS])
            }}
          >
            <img
              src={appStore}
              alt="Download on the App Store"
              className="h-12"
            />
          </div>
          <div
            className="cursor-pointer"
            onClick={() => {
              onOpenDownloadLink(DownloadLinkMap[DeviceTypes.ANDROID])
            }}
          >
            <img src={playStore} alt="Get it on Google Play" className="h-12" />
          </div>
        </div>
      </div>
    </BackgroundWrapper>
  )
}

export default EventBanner2
